import React, { useCallback } from "react";
import BreadCrumbs from "../../components/common/BreadCrumbs/BreadCrumbs";
import CommonErrorBanner from "../../components/common/CommonErrorBanner";
import { useNavigate } from "react-router";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  const handleBreadcrumbPrevious = useCallback((): void => {
    navigate("/home");
  }, [navigate]);

  return (
    <div className="min-h-[36vh] lg:mx-40! mx-5!">
      <div>
        <BreadCrumbs
          previousPage="UBT Home"
          onPreviousClick={handleBreadcrumbPrevious}
        />
      </div>
      <CommonErrorBanner
        heading="404 - Page Not Found"
        messageInfo="The page you requested could not be located. It may have been moved, deleted, or never existed."
      />
    </div>
  );
};

export default PageNotFound;
